import React from 'react';
import './styles.css';
import BasicButton from '../../../../components/BasicButton';

const FiltersMobileToggler = props => {
  const { title = 'Search Filters:', toggleFunc } = props;
  return (
    <div>
      <div className="filters-mobile-toggler">
        <p className="filters-mobile-toggler__description">{title}</p>
        <div className="filters-mobile-toggler__btn">
          <BasicButton
            btnWidth={130}
            btnHeight={35}
            btnFontWeight={600}
            btnText="Filters"
            btnArrow={true}
            btnHoverBg="#f40"
            controlFunc={toggleFunc}
          />
        </div>
      </div>
    </div>
  );
};

export default FiltersMobileToggler;
